import React, { useMemo, useState } from "react";

const TEXTS = {
  1: [
    "The life of such people is a constant struggle: as soon as one obstacle is overcome, a new one appears. Their natural store of talents and abilities helps them through.",
    "It’s also very important for them to demonstrate their organizational skills.",
  ],
  2: [
    "These people prefer living in a small community rather than surrounding themselves with “extra” people.",
    "Life keeps teaching them to seek compromises, sometimes yielding leadership positions, because they can’t think only of themselves. They handle unusual situations well and don’t chase money or social status.",
  ],
  3: [
    "These people are lucky to encounter good opportunities in their careers and beyond, but it’s more important for them to preserve the freedom of self-expression.",
    "They should avoid extremes and learn self-restraint to prevent conflicts and keep their balance.",
  ],
  4: [
    "These people have to make considerable efforts to get what they want. They never complain or ask for help—such resilience helps them a lot in life.",
    "They easily find compromises and know moderation in everything, yet they often face disappointment in romantic relationships. Numerologists advise: don’t judge others and try to understand everyone.",
  ],
  5: [
    "Change often happens in the lives of these people; they easily give in to impulses and like to experiment, though they should avoid that and plan their steps clearly.",
    "It’s vital for them to learn new things and travel—and loved ones can’t always keep up with their pace.",
  ],
  6: [
    "The main trait here is responsibility. It’s crucial for them to control everything and not allow themselves rest until the task is solved.",
    "They get along well with others and are ready to help everyone, but they themselves also need support and love.",
  ],
  7: [
    "These people have virtually limitless prospects, but they can reach their goals only by coming to terms with themselves.",
    "It’s important for them to learn to accept criticism and manage emotions; the worst way to limit themselves is to box into a narrow, highly specialized field.",
  ],
  8: [
    "This number promises the fulfillment of almost all desires. Such people can achieve high status, but they may exhaust those around them with their relentless drive.",
    "Money and status matter greatly to them, and they’re ready to work hard for it. Numerologists advise: in this race, don’t forget the spiritual side of life and give yourself a breather.",
  ],
  9: [
    "These people find it hard to focus on details, but they always see the big picture and understand what they’re doing and why.",
    "Their energy sometimes overflows; numerologists suggest channeling it into helping others—for example, into charity.",
  ],
};

function sumDigits(s) {
  return String(s)
    .split("")
    .reduce((a, ch) => a + (Number(ch) || 0), 0);
}
function toSingleDigit(n) {
  let x = Number(n) || 0;
  while (x > 9) x = sumDigits(String(x));
  return x === 0 ? 9 : x; // always show a card
}

export default function NumerologyTest({ title = "Calculate your number", note }) {
  const [date, setDate] = useState("");
  const [manual, setManual] = useState("");
  const [active, setActive] = useState(null);

  const computedNumber = useMemo(() => {
    const digits = (manual || "").replace(/\D/g, "") || (date || "").replaceAll("-", "");
    if (!digits) return null;
    return toSingleDigit(sumDigits(digits));
  }, [date, manual]);

  const text = active ? TEXTS[active] : null;

  return (
    <div className="card shadow-sm border-0" style={{ maxWidth: 900 }}>
      <div className="card-body">
        <h2 className="h5 mb-2">{title}</h2>

        <div className="row g-2 align-items-end">
          <div className="col-sm">
            <label className="form-label">Date of birth</label>
            <input
              type="date"
              className="form-control"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <div className="form-text">Or type digits below, e.g. 12061983</div>
          </div>
          
          <div className="col-auto">
            <button className="btn btn-primary" onClick={() => setActive(computedNumber)}>
              Show my result
            </button>
          </div>
        </div>

        <div className="row row-cols-3 row-cols-sm-9 g-2 mt-3">
          {Array.from({ length: 9 }, (_, i) => i + 1).map((n) => (
            <button
              key={n}
              type="button"
              className={"btn " + (active === n ? "btn-outline-secondary" : "btn-light")}
              onClick={() => setActive(n)}
            >
              {n}
            </button>
          ))}
        </div>

        {text && (
          <div className="mt-3 p-3 rounded-3 border border-success" style={{ background: "#ecfdf5" }}>
            <div className="d-flex align-items-center gap-2">
              <h3 className="h6 mb-0">Number {active}</h3>
              <strong className="text-success">✓</strong>
            </div>
            <p className="mb-2">{text[0]}</p>
            <p className="mb-0">{text[1]}</p>
            {note && <div className="text-muted small mt-2">{note}</div>}
          </div>
        )}
      </div>
    </div>
  );
}